export default __webpack_public_path__ + "static/media/t2.2260930e.jpg";